import { PlusIcon } from '@langchain/untitled-ui-icons';

import { Button } from '@/design-system';

import { HostListenerCrudPane } from './HostListenerCrudPane';

export function HostListenerCrudPaneWithButton({
  open,
  setIsOpen,
}: {
  open: boolean;
  setIsOpen: (open: boolean) => void;
}) {
  return (
    <>
      <Button
        size="md"
        onClick={() => setIsOpen(true)}
        leftDecorator={PlusIcon}
      >
        Create Listener
      </Button>
      <HostListenerCrudPane isOpen={open} doClose={() => setIsOpen(false)} />
    </>
  );
}
